import React from "react";

function PublicRoute({ children }) {
  return <>{children}</>;
}

export default PublicRoute;
